import { render, staticRenderFns } from "./DHV.vue?vue&type=template&id=1c5ea8c9&scoped=true"
import script from "./DHV.vue?vue&type=script&lang=js"
export * from "./DHV.vue?vue&type=script&lang=js"
import style0 from "./DHV.vue?vue&type=style&index=0&id=1c5ea8c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ea8c9",
  null
  
)

export default component.exports